<div fxLayout="row">
    <!-- <span>Local: {{ asOfDateTimeLocal }}</span>
    <span>Home: {{ asOfDateTimeHome }}</span> -->
    <div fxFlex="1 1 auto"></div>
    <div fxFlex="0 0 auto" fxLayoutAlign="center center">
        <button mat-icon-button class="" matTooltip="Start of Day" matTooltipPosition="below" (click)="onToStart()" [disabled]="lowerBoundReached">
            <span class="fa fa-step-backward"></span>
        </button>
        <button mat-icon-button class="" [matTooltip]="'Back '+ DOUBLE_MINUTES" matTooltipPosition="below" (click)="onDoubleBack()"
            [disabled]="lowerBoundReached">
            <!-- <span class="fa fa-backward"></span> -->
            <mat-icon>replay_30</mat-icon>
        </button>
        <button mat-icon-button class="" [matTooltip]="'Back '+ SINGLE_MINUTES" matTooltipPosition="below" (click)="onSingleBack()" [disabled]="lowerBoundReached">
            <!-- <span class="fa fa-chevron-left"></span> -->
            <mat-icon>replay_5</mat-icon>
        </button>
        <h3>{{ hour }}</h3>
        <h3>:</h3>
        <h3>{{ minutes }}</h3>
        <!-- <mat-form-field>
            <input matInput type="time" (change)="onTimeChange($event)" [(ngModel)]="time">
        </mat-form-field> -->
        <!-- <input type="time" pInputText [(ngModel)]="time" (change)="onTimeChange($event)">   -->
        <button mat-icon-button class="" [matTooltip]="'Forward '+ SINGLE_MINUTES" matTooltipPosition="below" (click)="onSingleForward()" [disabled]="upperBoundReached">
            <!-- <span class="fa fa-chevron-right"></span> -->
            <mat-icon>forward_5</mat-icon>
        </button>
        <button mat-icon-button class="" [matTooltip]="'Forward '+ DOUBLE_MINUTES" matTooltipPosition="below" (click)="onDoubleForward()" [disabled]="upperBoundReached">
            <!-- <span class="fa fa-forward"></span> -->
            <mat-icon>forward_30</mat-icon>
        </button>
        <button mat-icon-button class="" matTooltip="End of Day" matTooltipPosition="below" (click)="onToEnd()" [disabled]="upperBoundReached">
            <span class="fa fa-step-forward"></span>
        </button>
    </div>
    <div fxFlex="1 1 auto"></div>
</div>